<template>
  <div class="relative">
    <!-- add a button to hide and show the bubble charts-->

    <svg class="mt-8" :style="{ width: width + 'px', height: height + 'px' }">
      <g>
        <g>
          <mapPath
            v-for="geo in geoJsonDataStates"
            :id="geo.id"
            :key="geo.id"
            :d="geo.path===null ? '' : geo.path"
            class="stroke-white stroke-2 hover:brightness-125 duration-700"
            :class="{
              selectionable:
                geo.color !== nonAvailableColor || geo.id === selectedGeo,
              state: true,
              '!fill-Secondary-600': geo.id === selectedGeo,
              '!transition-all': afterRender,
            }"
            :selectionable="
              geo.color != nonAvailableColor || geo.id === selectedGeo
            "
            :color="geo.color"
            @_mouseover="onMouseover($event, geo.id)"
            @_mouseout="onMouseout($event, geo.id)"
            @_click="onClick($event, geo.id)"
          ></mapPath>
        </g>
      </g>
    </svg>
    <ClientOnly>
      <Teleport :to="teleportSelector" :enabled="enableTeleport">
        <div class="flex flex-row justify-start max-w-3xl mt-2 gap-3">
          <div
            v-for="(c, i) in legendRanges"
            :key="i"
            class="flex flex-row items-center gap-2"
          >
            <span
              class="circle"
              :style="{ 'background-color': colorScaleStates(c[0]) }"
            >
            </span>
            <span class="text-xs text-center text-Shades-SoftBlack">
              {{ $formater.salaryFormater(c[0]) }}-{{
                $formater.salaryFormater(c[1])
              }}
            </span>
          </div>
        </div>
      </Teleport>
    </ClientOnly>

    <br /><br /><br /><br />
    <!-- Out of the map: "_id": "Bilateral, unspecified", "TOTAL": 6365.055502, -->
  </div>
</template>

<script>
import * as d3 from "d3";
import * as geo from "d3-geo";
import * as worldmap from "~/assets/world-110m.json";
import {geoClipPolygon}  from "d3-geo-polygon"

import * as bubbles from "~/assets/testdb.devcol.json";
import mapPath from "./mapPath";
// when scale is 1: world map size is 6780 x 2950
const defaultMapWidth = 6000; // heuristically remove some space on the map
const defaultMapHeight = 2950;
const defaultMapRatio = defaultMapHeight / defaultMapWidth;
export default {
  components: {
    mapPath,
  },
  props: {
    showBubbleChart: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      required: true,
    },
    width: {
      type: Number,
      default: 1200,
    },
    metricObject: {
      type: Object,
      default: () => ({
        displayName: "Total",
        value: "Total",
        columnId: "Total",
      }),
    },
    colors: {
      type: Array,
      default: () => [
        "#004c6d",
        "#346888",
        "#5886a5",
        "#7aa6c2",
        "#9dc6e0",
        "#c1e7ff",
      ],
    },
    nonAvailableColor: {
      type: String,
      default: "#CCD6D8",
    },
    bgColor: {
      type: String,
      default: "#08476D",
    },
    selectedGeo: {
      type: String,
      default: "-",
    },
    hasSelectedCountry: {
      type: Boolean,
      default: false,
    },
    teleportSelector: {
      type: String,
      default: "",
    },
    mapScale: {
      type: String,
      default: "quantile",
    },
  },
  data() {
    return {
      countyFipsToGeometry: null,
      geoPath: geo.geoPath(),
      geoJsonDataStates: [],
      // when scale is 1: world map size is 6780 x 2950
      afterRender: false,
      bubbles: bubbles.default,
      zoomGeoId: null,
      showZoomControls: false,

    };
  },
  computed: {
    zoomData() {
      return {
        x: this.width / 2.5,
        y: this.height / 2,
        scale: 1,
      };
    },
    showBubbleChart2() {
      return this.showBubbleChart && this.hasSelectedCountry === false;
    },
    height() {
      return this.width * defaultMapRatio * 1.1;
    },

    colorSteps() {
      return this.colors;
    },
    legendRanges() {
      const ranges = [];
      // ranges.push([0, this.colorScaleCounties.invertExtent(this.colorSteps[1])])
      for (let i = 0; i < this.colorSteps.length; i++) {
        const range = this.colorScaleStates.invertExtent(this.colorSteps[i]);
        if (range[0] !== undefined && range[1] !== undefined)
          ranges.push(range);
      }
      return ranges;
    },
    colorScaleStates() {
      if (this.mapScale === "quantile")
        return d3
          .scaleQuantile()
          .domain(this.dataArrayValuesMetric)
          .range(this.colorSteps);
      else
        return d3
          .scaleQuantize()
          .domain(d3.extent(this.dataArrayValuesMetric))
          .range(this.colorSteps);
    },
    // colorScale() {
    //   if (this.geoArea === this.geoTypes.counties) return this.colors
    //   else return ['F7F7F8', 'F7F7F8', 'F7F7F8']
    // },

    dataArrayValuesMetric() {
      return this.data.map((d) => parseFloat(d[this.metricObject.columnId]));
    },
    currentGeoJson() {
      return this.geoJsonDataStates;
    },
    bubbleData() {
      // transform lat and lng to x and y and add radius depending on TOTAL
      return this.bubbles.map((d) => {
        return {
          cx: this.projection([d.lng, d.lat])[0],
          cy: this.projection([d.lng, d.lat])[1],
          r: this.radiusScale(d["TOTAL"]),
          total: d["TOTAL"],
          id: d._id,
        };
      });
    },
    radiusScale() {
      return d3
        .scaleSqrt()
        .domain(d3.extent(this.bubbles, (d) => parseFloat(d["TOTAL"])))
        .range([1, 200]);
    },
    enableTeleport() {
      return this.teleportSelector !== "";
    },
  },
  watch: {
    width(newValue, oldValue) {
      this.resetProjection();
      this.setGeoJsonDataStates();
      // console.log('reset projectsion0')
    },
    mapScale(newValue, oldValue) {
      this.setGeoJsonDataStates();
    },
    data() {
      this.setGeoJsonDataStates();
    },

    metricObject() {
      this.setGeoJsonDataStates();
    },
    // dataComputedFinished(newValue, oldValue) {
    //   console.log('dataComputedFinished ' + newValue)
    //   if (newValue == true) {

    //   }
    // },
  },
  created() {
    this.resetProjection();
  },
  mounted() {
    this.setGeoJsonDataStates();
    this.$nextTick(() => {
      this.afterRender=true
    })
    // window.addEventListener('resize', this.resizeWindow)
    // this.resizeWindow()
  },
  unmounted() {
    // window.removeEventListener('resize', this.resizeWindow)
  },
  methods: {
    toggleBubbleChart() {
      this.showBubbleChart = !this.showBubbleChart;
    },

    checkNumberIsAvailable(n) {
      if (n === null || n === undefined || n === "" || isNaN(n)) return false;
      else return true;
    },

    setGeoJsonDataStates() {
      this.geoJsonDataStates = worldmap.features.map((d) => {
        return {
          path: this.geoPath(d),
          id: d.id,
          name: d.properties.name,
          bounds: this.geoPath.bounds(d),
          color: this.colorFromData(d.id),
        };
      });
    },
    resetProjection(projectionRatio = 1) {
      this.projection = geo
        .geoNaturalEarth1()
        .preclip(
          geoClipPolygon({
            type: "Polygon",
            coordinates: [              
            [
              [-150, -50], //first coordinate seems to be about width ( longitude) second one.. no idea works by try and error
              [-150, 50], 
              [160, 50], 
              [160, -50],
               [-150, -50]]
                
                
            ],
          })
        )
        .fitWidth(this.width, worldmap);
      this.geoPath.projection(this.projection);
    },
    datumFromGeoId(geoId) {
      return this.data.find((d) => d._id === geoId);
    },
    colorFromData(regionID) {
      const element = this.data.find((d) => {
        return d._id === regionID;
      });
      if (element) {
        if (
          element.total_demand < this.$THRESHOLD ||
          isNaN(element[this.metricObject.columnId])
        )
          return " this.nonAvailableColor";
        else return this.colorScaleStates(element[this.metricObject.columnId]);
      }
      return this.nonAvailableColor;
    },

    onClick(event, geoid) {
      this.$emit("_click", geoid);
    },

    onMouseover(event, geoId) {
      const name = this.currentGeoJson.find((d) => d.id === geoId).name;
      if (geoId === this.selectedGeo) return;
      // emit mouseover
      this.$emit("_mouseover", {
        value: this.datumFromGeoId(geoId)[this.metricObject.columnId],
        name,
        x: event.pageX,
        y: event.pageY,
      });
    },

    onMouseout(event, geoId) {
      if (geoId === this.selectedGeo) return;
      this.$emit("_mouseout", {
        geoId,
      });
    },
    resizeWindow() {
      if (window.innerWidth < 1024) {
        this.zoomData.x = window.innerWidth / 2.5;
        this.zoomData.y = window.innerWidth / 4;
      } else if (window.innerWidth < 1200) {
        this.zoomData.x = window.innerWidth / 4;
        this.zoomData.y = window.innerWidth / 6;
      } else if (window.innerWidth < 1500) {
        this.zoomData.x = 400;
        this.zoomData.y = 240;
      } else {
        this.zoomData.x = 520;
        this.zoomData.y = 250;
      }
    },
  },
};
</script>

<style lang="css" scoped>

span.circle {
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  vertical-align: top;
}
</style>
